import { Skeleton } from 'antd'
import styles from '../../../../../testrun.module.css'

export default function SkeletonResultForm({
    showBanner = true,
    showAttachments = true,
    attachmentThumbs = 2,
}) {
    return (
        <div className={styles.resultSkeletonWrap}>
            {showBanner && (
                <div className={styles.resultCaseBanner}>
                    <div className={styles.resultCaseBannerTop}>
                        <Skeleton.Input
                            active
                            size="small"
                            style={{ width: 72, minWidth: 72, height: 22 }}
                        />
                        <Skeleton.Button
                            active
                            size="small"
                            style={{
                                width: 64,
                                minWidth: 64,
                                height: 24,
                                borderRadius: 999,
                            }}
                        />
                    </div>
                    <Skeleton.Input
                        active
                        size="small"
                        style={{
                            width: '78%',
                            maxWidth: 280,
                            height: 18,
                            marginTop: 8,
                        }}
                    />
                </div>
            )}

            <section className={styles.resultFormCard}>
                <div className={styles.resultSkeletonForm}>
                    <Skeleton.Input
                        active
                        size="small"
                        style={{ width: 72, minWidth: 72, height: 12 }}
                    />
                    <Skeleton.Input
                        active
                        size="small"
                        style={{
                            width: 140,
                            minWidth: 140,
                            height: 20,
                            marginTop: 6,
                            marginBottom: 4,
                        }}
                    />

                    <div className={styles.resultSkeletonField}>
                        <Skeleton.Input
                            active
                            size="small"
                            style={{ width: 52, minWidth: 52, height: 12 }}
                        />
                        <Skeleton.Input
                            active
                            style={{
                                width: '100%',
                                height: 36,
                                borderRadius: 8,
                            }}
                        />
                    </div>

                    <div className={styles.resultSkeletonField}>
                        <Skeleton.Input
                            active
                            size="small"
                            style={{ width: 68, minWidth: 68, height: 12 }}
                        />
                        <Skeleton
                            active
                            title={false}
                            paragraph={{ rows: 3, width: ['100%', '100%', '72%'] }}
                        />
                    </div>

                    {showAttachments && (
                        <div className={styles.resultSkeletonField}>
                            <Skeleton.Input
                                active
                                size="small"
                                style={{
                                    width: 88,
                                    minWidth: 88,
                                    height: 12,
                                }}
                            />
                            <div className={styles.resultSkeletonThumbs}>
                                {Array.from({
                                    length: attachmentThumbs,
                                }).map((_, i) => (
                                    <Skeleton.Image
                                        key={i}
                                        active
                                        style={{
                                            width: 88,
                                            height: 88,
                                            borderRadius: 8,
                                        }}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </div>
    )
}
